import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';

// Components
import Hero from './components/Hero';
import Services from './components/Services';
import Benefits from './components/Benefits';
import ServiceArea from './components/ServiceArea';
import Pricing from './components/Pricing';
import Comparison from './components/Comparison';
import Testimonials from './components/Testimonials';
import About from './components/About';
import Contact from './components/Contact';
import Providers from './components/Providers';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import SafeIcon from './common/SafeIcon';

import './App.css';

const { FiArrowUp } = FiIcons;

function App() {
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 400);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className="min-h-screen bg-white">
      <AnimatePresence mode="wait">
        <Routes>
          <Route path="/" element={
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.5 }}
            >
              <Hero />
              <Services />
              <Benefits />
              <ServiceArea />
              <Pricing />
              <Comparison />
              <Testimonials />
              <About />
              <Providers />
              <FAQ />
              <Contact />
              <Footer />
            </motion.div>
          } />
        </Routes>
      </AnimatePresence>

      {/* Back to Top Button */}
      <AnimatePresence>
        {showBackToTop && (
          <motion.button
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0 }}
            transition={{ duration: 0.3 }}
            onClick={scrollToTop}
            className="fixed bottom-8 right-8 bg-blue-600 hover:bg-blue-700 text-white p-4 rounded-full shadow-lg z-50 transition-colors"
            aria-label="Back to top"
          >
            <SafeIcon icon={FiArrowUp} className="w-6 h-6" />
          </motion.button>
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;